export default __webpack_public_path__ + "static/media/feasibility.dd085da5.svg";